export default function () {
  this.$http({
    method: 'get',
    url: this.exportFunction.url,
    responseType: 'arraybuffer'
  })
  .then(res => {
    const url = window.URL.createObjectURL(new Blob([res.data]))
    const link = document.createElement('a')
    link.href = url
    link.setAttribute('download', this.exportFunction.fileName + '.xlsx') //or any other extension
    document.body.appendChild(link)
    link.click()
    link.remove()
  })
  .catch(() => console.log('error occured'))
}